import React from 'react';

import classNames from 'classnames';

import styles from './fetching.module.css';

const Fetching = ({
    isFetching,
    children
}: {
    isFetching: boolean;
    children: React.ReactNode;
}) => {
    return (
        <span
            className={classNames({
                [styles.fetching]: isFetching
            })}
        >
            {children}
        </span>
    );
};

// eslint-disable-next-line import/no-default-export
export default Fetching;
